const fromAnyToUmsgArg = (value) => value?.arg;

export default fromAnyToUmsgArg;
